import FormType from "../../Components/Form2/FormType";
import powersource from "../../Assets/Images/powersource_location_one.jpeg";
import cableroute from "../../Assets/Images/planned_cable_route.png";

const PowerSourcesFormOptions = (init = {}) => {
  return {
    Fields: [
      {
        element: FormType.Input,
        name: "distancePowerSource1",
        label: "Distance to Power Source for Location 1 (in meters)",
        value: init.distancePowerSource1 || "",
        required: true,
        info: "Power source location",
        infoImage: powersource,
      },
      {
        element: FormType.FileUpload,
        name: "powerSource1",
        label: "Power Source for Location 1",
        description: "Select an image of the power source 1",
        value: init.powerSource1 || [],   
        required: true,
		fileTypes: "image"
      },
      {
        element: FormType.Input,
        name: "distancePowerSource2",
        label: "Distance to Power Source for Location 2 (in meters)",
        value: init.distancePowerSource2 || "",
        required: true,
        info: "Power source location",
        infoImage: powersource,
      },
      {
        element: FormType.FileUpload,
        name: "powerSource2",
        label: "Power Source for Location 2",
        description: "Select an image of the power source 2",
        value: init.powerSource2 || [],   
        required: true,
		fileTypes: "image"
      },
      {
        element: FormType.Input,
        name: "backupPowerSource",
        label: "Backup Power Source, e.g., UPS",
        value: init.backupPowerSource || "",
      },
      {
        element: FormType.TextArea,
        name: "cableRouteDescription",
        label: "Cable Route Description",
        description:
          "Plan the route for cabling from the installation site to your desired network equipment location inside the building.",
        value: init.cableRouteDescription || "",
        placeholder: "e.g Route cable from floor to server room inside",
        info: "Power source location",
        infoImage: powersource,
        required: true,
      },
      {
        element: FormType.Input,
        name: "cableLengthEstimate",
        label: "An estimate of cable run length (in meters)",
        value: init.cableLengthEstimate || "",
        required: true,
        info: "Power source location",
        infoImage: cableroute,
      },
      {
        element: FormType.FileUpload,
        name: "plannedCableRoute",
        label: "Planned Cable Route",
        description: "Upload a video of planned cable route.",
        value: init.plannedCableRoute || [],   
        required: true,
		fileTypes: "video"
      },
    ],
  };
};

export default PowerSourcesFormOptions;
